import { render, staticRenderFns } from "./PagePaginate.vue?vue&type=template&id=4e084623"
import script from "./PagePaginate.vue?vue&type=script&lang=js"
export * from "./PagePaginate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports